import type { ChecklistDay, ChecklistLine, ChecklistLineCheck } from '../../types/checklists'
import { request, requestBlob, requestUpload } from './http'

export const getChecklistDay = (date: string | null) => request<ChecklistDay>(date ? `/checklists?date=${date}` : '/checklists')

export const checkChecklistLine = (id: number, body: ChecklistLineCheck) =>
	request<ChecklistLine>(`/checklists/items/${id}`, { method: 'PATCH', body: JSON.stringify(body) })

export const uploadChecklistPhoto = (id: number, file: File) => requestUpload<ChecklistLine>(`/checklists/items/${id}/photo`, file)

export const getChecklistPhoto = (id: number) => requestBlob(`/checklists/items/${id}/photo`)

export const signOffChecklist = (runId: number) => request<{ run_id: number }>(`/checklists/runs/${runId}/complete`, { method: 'POST' })
